<template>
    <div class="textfield-select">
        <div
            class="form-group select"
            :class="{ 'form-group-floating-label': $slots.default }"
        >
            <select
                v-model="localValue"
                :name="name"
                :required="required"
                class="input"
                :tabindex="tabindex"
                :disabled="disabled"
            >
                <option
                    v-if="placeholder"
                    value=""
                    disabled
                >
                    {{ placeholder }}
                </option>

                <option
                    v-for="option in objectOptions"
                    :value="option[valueKey]"
                >
                    {{ option[labelKey] }}
                </option>
            </select>

            <label v-if="$slots.default" class="floating-label">
                <slot />
            </label>

            <div class="pointer-events-none absolute pin-y pin-r flex items-center px-lg text-neutral-dark">
                <svg
                    class="fill-current h-md w-md"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                >
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: [String, Number],
                required: false,
                default: null,
            },
            options: {
                type: Array,
                required: true,
            },
            labelKey: {
                type: String,
                default: 'label',
            },
            valueKey: {
                type: String,
                default: 'value',
            },
            name: {
                required: true,
                type: String,
            },
            placeholder: {
                required: false,
                type: String,
                default: null,
            },
            required: {
                required: false,
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: null,
            },
            tabindex: {
                type: Number,
                default: null,
            },
        },
        data() {
            return {
                localValue: this.value,
            };
        },
        computed: {
            objectOptions() {
                if (typeof this.options[0] === 'object') {
                    return this.options;
                }

                // Transform flat arrays to object { labelKey: label, valueKey: value }-format
                return this.options.map(item => ({
                  [this.labelKey]: item,
                  [this.valueKey]: item,
                }));
            },
        },
        watch: {
            localValue(newValue) {
                if (newValue === this.value) {
                    return;
                }

                if (typeof newValue === 'object') {
                    newValue = newValue[this.valueKey];
                }

                this.$emit('input', newValue);
            },
            value(newValue) {
                if (newValue === this.localValue) {
                    return;
                }

                this.localValue = newValue;
            },
        },
        created() {
            // Set default to first option value to mimic a native select
            if (this.localValue === null) {
                this.localValue = this.options[Object.keys(this.options)[0]];
            }
        },
    };
</script>